const STORAGE_KEY = 'us-job-board-nav';

interface NavState {
  ids: number[];
  searchUrl: string;
  searchText: string;
}

export const setJobNavState = (state: NavState): void => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // sessionStorage may be unavailable in private mode — silently noop
  }
};

export const getJobNavState = (): NavState | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as NavState;
  } catch {
    return null;
  }
};
